import React from 'react';
import { PageWrapper } from '../../elements';

import { Image, Title, Text } from './elements';
import { useText, useConfig } from 'common/hooks';

export default function Success(): React.ReactElement {
  const t = useText();
  const { staticUrl } = useConfig();

  return (
    <PageWrapper>
      <Image alt={''} src={`${staticUrl}/images/password-icon.png`} />
      <Title as={'h2'}>{t('authentication.password_created')}</Title>
      <Text>{t('authentication.use_next_time')}</Text>
    </PageWrapper>
  );
}
